import { render, staticRenderFns } from "./Edition.vue?vue&type=template&id=d91850ec&scoped=true&"
import script from "./Edition.vue?vue&type=script&lang=js&"
export * from "./Edition.vue?vue&type=script&lang=js&"
import style0 from "./Edition.vue?vue&type=style&index=0&id=d91850ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d91850ec",
  null
  
)

export default component.exports